<app-loader *ngIf="isLoading"></app-loader>
<div class="d-flex flex-wrap justify-content-between align-items-center mb-3">
  <div>
    <h4 class="q-heading">
      <span><img [src]="'IMAGES.BACKARROW'|translate" (click)="goBack()" alt="" class="me-2 cursor-pointer" /></span>
      {{ "MANAGEDEVICE.LOCK" | translate }} / {{ "MANAGEDEVICE.UNLOCK" | translate }}
    </h4>
  </div>

  <div class="ms-auto">
    <form [formGroup]="restorePublishForm">
      <select class="form-select bg-transparent" formControlName="mobileDeviceName"
        (change)="onMobileDeviceSelect($event)">
        <option *ngFor="let item of mobileDevice" [value]="item.id">
          {{ item.deviceName }}
        </option>
      </select>
    </form>
  </div>
</div>

<div class="commandsBG-WHITE mb-5 mb-md-0 text-center">
  <div class="row">
    <div class="col-md-12 mb-3">
      <img [src]="'MANAGEDEVICE.LOCKILLIMG'|translate" alt="" class="w-200" />
    </div>
    <p class="mb-0">{{ "MANAGEDEVICE.LOCKTEXT" | translate }}</p>
    <p class="mb-3">{{ "MANAGEDEVICE.LOCKTEXT1" | translate }}</p>
  </div>

  <div class="row mb-0 mb-md-5">
    <div class="col-md-12">
      <button type="button" class="submit-btn bg-orgclr shadow-none me-3 w-auto" (click)="openLockModal()">
        {{ "MANAGEDEVICE.LOCK" | translate }}
      </button>
      <button type="button" class="submit-btn bg-orgclr shadow-none me-3 w-auto" (click)="openUNLockModal()">
        {{ "MANAGEDEVICE.UNLOCK" | translate }}
      </button>
    </div>
  </div>
</div>

<div class="modal mx-auto fade fixed top-0 left-0 w-100 h-100 outline-none overflow-y-auto" id="LockPopup"
  data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel"
  aria-hidden="true">
  <div class="modal-dialog relative w-auto pointer-events-none modal-dialog-centered text-center">
    <div class="modal-content border-none px-4 shadow-lg relative pointer-events-auto rounded-25 bg-white outline-none">
      <ng-container *ngIf="!isLock">
        <div class="mt-4">
          <img [src]="'MANAGEDEVICE.LOCKIMG'|translate" alt="" class="mx-auto" />
        </div>
        <h4 class="q-modal-heading mt-2 fw-bold">
          {{ "SUCESSMESSAGE.DOYOUWANTTOLOCK" | translate }}
        </h4>
        <ng-container *ngIf="errorMessage">
          <p class="errMessage" style="margin: 10px 90px">{{ errorMessage }}</p>
        </ng-container>
        <div class="text-center mb-4 d-flex justify-content-center">
          <div class="me-3">
            <button type="button" class="submit-btn bg-orgclr" (click)="sendCommand('BLOCK')">
              {{ "MANAGEDEVICE.LOCK" | translate }}
            </button>

          </div>
          <div class="">
            <button type="button" class="cancel-btn bg-cancelbtn" data-bs-dismiss="modal" (click)="closeModal()">
              {{ "LOGIN.CANCEL" | translate }}
            </button>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="isLock">
        <div class="mt-4">
          <img [src]="'SIGNUP.SUCCESSIMG'|translate" alt="" class="mx-auto" />
        </div>
        <h5 *ngIf="Locked" class="fw-bold mt-4 deleteUser">
          {{ "SUCESSMESSAGE.DEVICELOCKSUCCESSFULLY" | translate }}
        </h5>
        <h5 *ngIf="!Locked" class="fw-bold mt-4 deleteUser">
          {{ "SUCESSMESSAGE.DEVICEUNLOCKSUCCESSFULLY" | translate }}
        </h5>
        <div class="text-center">
          <div class="text-lg font-normal">
            <button type="button" class="submit-btn bg-orgclr w-auto mt-4 mb-4" data-bs-dismiss="modal">
              {{ "SIGNUP.DONE" | translate }}
            </button>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>


<div class="modal mx-auto fade fixed top-0 left-0 w-100 h-100 outline-none overflow-y-auto" id="UNLockPopup"
  data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel"
  aria-hidden="true">
  <div class="modal-dialog relative w-auto pointer-events-none modal-dialog-centered text-center">
    <div class="modal-content border-none px-4 shadow-lg relative pointer-events-auto rounded-25 bg-white outline-none">
      <ng-container *ngIf="!isLock">
        <div class="mt-4">
          <img [src]="'MANAGEDEVICE.LOCKIMG'|translate" alt="" class="mx-auto" />
        </div>
        <h4 class="q-modal-heading mt-2 fw-bold">
          {{ "SUCESSMESSAGE.DOWANTTOUNLOCK" | translate }}
        </h4>
        <ng-container *ngIf="errorMessage">
          <p class="errMessage" style="margin: 10px 90px">{{ errorMessage }}</p>
        </ng-container>
        <div class="text-center mb-4 d-flex justify-content-center">
          <div class="me-3">
            <button type="button" class="submit-btn bg-orgclr" (click)="sendCommand('UNLOCK')">
              {{ "MANAGEDEVICE.UNLOCK" | translate }}
            </button>
          </div>
          <div class="">
            <button type="button" class="cancel-btn bg-cancelbtn" data-bs-dismiss="modal" (click)="closeModal()">
              {{ "LOGIN.CANCEL" | translate }}
            </button>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="isLock">
        <div class="mt-4">
          <img [src]="'SIGNUP.SUCCESSIMG'|translate" alt="" class="mx-auto" />
        </div>
        <h5 *ngIf="Locked" class="fw-bold mt-4 deleteUser">
          {{ "SUCESSMESSAGE.DEVICELOCKSUCCESSFULLY" | translate }}
        </h5>
        <h5 *ngIf="!Locked" class="fw-bold mt-4 deleteUser">
          {{ "SUCESSMESSAGE.DEVICEUNLOCKSUCCESSFULLY" | translate }}
        </h5>
        <div class="text-center">
          <div class="text-lg font-normal">
            <button type="button" class="submit-btn bg-orgclr w-auto mt-4 mb-4" data-bs-dismiss="modal">
              {{ "SIGNUP.DONE" | translate }}
            </button>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>